module.exports = __webpack_public_path__ + "img/local-26.4f3a5d3a.jpg";